import { ActionReducer, INIT, UPDATE } from "@ngrx/store";

export const localStorageSyncReducer = (reducer: ActionReducer<any>): ActionReducer<any> => {
    return (state, action) => {
        if (action.type === INIT || action.type === UPDATE) {
            const storedState = localStorage.getItem('state');
            if (storedState) {
                return JSON.parse(storedState);
            }
        }
        const nextState = reducer(state, action);
        localStorage.setItem('state', JSON.stringify(nextState));
        return nextState;
    };
}